<div class="card">
  <app-header
    titulo="Contratos novos"
    descricao="Realizar a integração dos contratos ainda não integrados"
  ></app-header>


  <app-contratos statusContrato="NI"></app-contratos>

</div>
